export default "__VITE_ASSET__BHSxOMDf__"